<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import ExcelExport from "@/components/ExcelExport.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Customer Deposits",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    ExcelExport,
  },
  data() {
    return {
      title: "Customer Deposits ",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Customers Deposits",
          active: true,
        },
      ],
      pageOptions: [10, 25, 50, 100, 200, 1000],
      clientCurrentPage: 1,
      clientPerPage: 10,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "customer",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "mode",
          sortable: true,
          label: "MODE",
        },
        {
          key: "description",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "user",
          sortable: true,
          label: "ADDED By",
        },
        {
          key: "added_on",
          sortable: true,
          label: "DATE ADDED",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingCustomer: [],
      amountError: "",
      dateError: "",
      customerError: "",
      modeError: "",
      nameError: "",
      contactError: "",

      // Value from user input for adding a deposit
      data: {
        customer: "",
        amount: "",
        mode: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        description: "",
        filterdata: {},
        payments: [{ method: null, amount: "" }], // For split payments
      },
      // edit unit
      editdata: {
        date: "",
        amount: "",
        description: "",
        id: "",
        filterdata: {},
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
        filterdata: {},
      },

      // Adding new customer
      customerdata: {
        name: "",
        contact: "",
      },

      splitPaymentActive: false,

      // merge data
      mergedata: {
        name: "",
        customer: "",
        id: "",
      },

      filterDeposits: {
        search: "",
        page: 1,
        per_page: 50,
        datefrom: moment().subtract(1, "months").format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("customers", [
      "SaveStatus",
      "Customers",
      "CustomerDeposits",
      "DepositsPaginated",
      "DepositsPagination",
      "IsDepositsServerPaginated",
      "DepositsFilterStatus",
      "DepositsSummary",
    ]),
    ...mapGetters("setting", ["PaymentOptions", "ReceiptSettings"]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapState("customers", ["depositId"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.IsDepositsServerPaginated
        ? this.DepositsPagination.total
        : this.DespositsPaginated
        ? this.DespositsPaginated.length
        : 0;
    },
    currentPage: {
      get() {
        return this.IsDepositsServerPaginated
          ? this.DepositsPagination.current_page
          : this.clientCurrentPage;
      },
      set(value) {
        if (this.IsDepositsServerPaginated) {
          this.handlePageChange(value);
        } else {
          this.clientCurrentPage = value;
        }
      },
    },
    perPage: {
      get() {
        return this.IsDepositsServerPaginated
          ? this.DepositsPagination.per_page
          : this.clientPerPage;
      },
      set(value) {
        if (this.IsDepositsServerPaginated) {
          this.handlePerPageChange(value);
        } else {
          this.clientPerPage = value;
        }
      },
    },

    totals() {
      return (
        this.DepositsSummary || {
          totalAmount: 0,
        }
      );
    },

    exportPayload() {
      return {
        ...this.filterDeposits,
      };
    },

    isLoading() {
      return this.DespositsFilterStatus;
    },

    totalPaidFromSplits() {
      if (!this.data.payments || this.data.payments.length === 0) {
        return 0;
      }
      return this.data.payments.reduce((acc, payment) => {
        const amount =
          parseFloat(String(payment.amount).replace(/,/g, "")) || 0;
        return acc + amount;
      }, 0);
    },

    /**
     * Todo list of records
     */
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    depositId(newValue) {
      if (newValue && this.ReceiptSettings.print_deposits == 1) {
        window.open(
          `https://${
            window.location.host
          }/receipts/depositreceipt.php?id=${btoa(newValue)}`,
        );
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCustomerDeposits: "customers/fetchCustomerDeposits",
      FetchCustomers: "customers/fetchCustomers",
      FetchPaymentOptions: "setting/fetchPaymentOptions",
      AddCustomerDeposit: "customers/addCustomerDeposit",
      EditCustomerDeposit: "customers/editCustomerDeposit",
      DeleteCustomerDeposit: "customers/deleteCustomerDeposit",
      AddCustomer: "customers/addCustomer",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered() {
      if (!this.IsDepositsServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },

    FilterReport() {
      this.filterDeposits.page = 1;
      this.FetchCustomerDeposits(this.filterDeposits);
    },

    handlePageChange(newPage) {
      if (this.IsDepositsServerPaginated) {
        const payload = {
          ...this.filterDeposits,
          page: newPage,
        };
        this.filterDeposits.page = newPage;
        this.FetchCustomerDeposits(payload);
      }
    },

    handlePerPageChange(newPerPage) {
      if (this.IsDepositsServerPaginated) {
        const payload = {
          ...this.filterDeposits,
          page: 1,
          per_page: newPerPage,
        };
        this.filterDeposits.page = 1;
        this.filterDeposits.per_page = newPerPage;
        this.FetchCustomerDeposits(payload);
      }
    },

    calculateIndex(index) {
      if (this.IsDepositsServerPaginated) {
        return this.DepositsPagination.from - 1 + index;
      } else {
        return this.clientPerPage * (this.clientCurrentPage - 1) + index;
      }
    },

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addCustomerDeposit(modalId) {
      this.modal_id = modalId;
      this.data.amount = this.data.amount.replaceAll(/,/g, "");
      if (this.data.date === "") {
        this.dateError = "Date  field is required";
        return;
      } else {
        this.dateError = "";
      }
      if (this.data.date > moment(new Date()).format("YYYY-MM-DD")) {
        this.dateError = "Dat cannot be greater than today";
        return;
      } else {
        this.dateError = "";
      }

      if (this.data.customer === "") {
        this.customerError = "Customer  field is required";
        return;
      } else {
        this.customerError = "";
      }

      if (this.data.amount === "") {
        this.amountError = "Amount field is required";
        return;
      } else {
        this.amountError = "";
      }

      if (this.splitPaymentActive) {
        this.data.payments = this.data.payments.filter(
          (p) =>
            p.method &&
            p.amount &&
            parseFloat(String(p.amount).replace(/,/g, "")) > 0,
        );
        if (this.data.payments.length === 0) {
          this.modeError = "At least one valid split payment is required.";
          return;
        }
        this.data.amount = this.totalPaidFromSplits;
      } else {
        if (!this.data.mode) {
          this.modeError = "Payment Method is required.";
          return;
        }
        this.data.amount =
          parseFloat(String(this.data.amount).replace(/,/g, "")) || 0;
        this.data.payments = [
          { method: this.data.mode, amount: this.data.amount },
        ];
      }
      this.modeError = "";

      this.data.filterdata = this.filterDeposits;
      this.AddCustomerDeposit(this.data);
    },

    resetAdd() {
      this.data.customer = "";
      this.data.amount = "";
      this.data.mode = "";
      this.data.description = "";
      this.modal_id = "";
      this.resetSplitPayments();
    },

    resetCustomerAdd() {
      this.customerdata.name = "";
      this.customerdata.contact = "";
      this.modal_id = "";
    },

    resetEdit() {
      this.editdata.date = "";
      this.editdata.amount = "";
      this.editdata.description = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.customerError = "";
      this.amountError = "";
      this.dateError = "";
      this.modeError = "";
      this.nameError = "";
      this.contactError = "";
    },
    showEditModal(val) {
      this.editdata.amount = this.thousandSeprator(val.amount);
      this.editdata.description = val.description;
      this.editdata.date = val.date;
      this.editdata.id = val.id;
    },
    editCustomerDeposit(modalId) {
      this.modal_id = modalId;
      if (this.editdata.amount < 0 || this.editdata.amount == "") {
        this.amountError = "Amount should be greater than 0";
        return;
      } else {
        this.amountError = "";
      }
      if (this.editdata.date == "") {
        this.dateError = "Date field is required";
        return;
      } else {
        this.dateError = "";
      }
      this.editdata.filterdata = this.filterDeposits;
      this.EditCustomerDeposit(this.editdata);
    },
    validateCustomerEdit() {
      if (this.editdata.name != "" && this.editdata.contact != "") {
        let selCust = this.Customers.filter((item) => {
          return (
            item.phone == parseInt(this.editdata.contact) &&
            item.id != this.editdata.id
          );
        });
        let custCount = selCust.length;
        if (custCount > 0) {
          this.customerError =
            "Customer with contact " +
            this.editdata.contact +
            "  already Exists";
        }
      }
    },
    showDeleteModal(val) {
      this.deletedata.name = val.customer;
      this.deletedata.id = val.id;
    },
    deleteCustomerDeposit(modalId) {
      this.modal_id = modalId;
      this.deletedata.filterdata = this.filterDeposits;
      this.DeleteCustomerDeposit(this.deletedata);
    },

    AddCommas() {
      this.data.amount = this.thousandSeprator(this.data.amount);
      this.editdata.amount = this.thousandSeprator(this.editdata.amount);
    },

    addCustomer(modalId) {
      this.modal_id = modalId;

      if (this.customerdata.name === "") {
        this.nameError = "Name  field is required";
        return;
      } else {
        this.nameError = "";
      }

      if (this.customerdata.contact === "") {
        this.contactError = "Contact field is required";
        return;
      } else {
        this.contactError = "";
      }

      this.validateCustomer();
      if (this.contactError != "") {
        return;
      }
      this.AddCustomer(this.customerdata);
    },

    validateCustomer() {
      if (this.customerdata.name != "" && this.customerdata.contact != "") {
        let selCust = this.Customers.filter((item) => {
          return item.phone == parseInt(this.customerdata.contact);
        });
        let custCount = selCust.length;
        if (custCount > 0) {
          this.contactError =
            "Customer with contact " +
            this.customerdata.contact +
            "  already Exists";
        }
      }
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    setDefaultMode() {
      let defaultop = this.PaymentOptions
        ? this.PaymentOptions
        : [].filter((mode) => {
            return mode.default == 1;
          });
      this.data.mode = defaultop[0] ? defaultop[0].id : 0;
    },

    // *** SPLIT PAYMENT LOGIC ***
    submitSplits(modalId) {
      this.data.payments = this.data.payments.filter(
        (p) =>
          p.method &&
          p.amount &&
          parseFloat(String(p.amount).replace(/,/g, "")) > 0,
      );
      if (this.data.payments.length === 0) {
        this.data.payments.push({ method: null, amount: "" });
        return;
      }

      this.isSubmittingSplits = true;
      this.splitPaymentActive = true;
      const totalFromSplits = this.totalPaidFromSplits;
      this.data.amount = totalFromSplits.toLocaleString();
      this.closeModal(modalId);
    },

    onPaymentsModalHidden() {
      if (this.isSubmittingSplits) {
        this.isSubmittingSplits = false;
      } else {
        this.resetSplitPayments();
      }
    },

    resetSplitPayments() {
      const originalPayments = this.splitPaymentActive
        ? [{ method: null, amount: "" }]
        : this.data.payments;
      this.data.payments = originalPayments;

      if (this.splitPaymentActive) {
        this.data.amount = 0;
        this.splitPaymentActive = false;
      }
    },
    // End of Split Payments

    checkAndAddPaymentField(index) {
      const lastIndex = this.data.payments.length - 1;
      const currentPayment = this.data.payments[index];
      if (
        index === lastIndex &&
        currentPayment.amount &&
        currentPayment.method
      ) {
        this.data.payments.push({ method: null, amount: "" });
      }
    },

    removePaymentField(index) {
      if (this.data.payments.length > 1) {
        this.data.payments.splice(index, 1);
      }
    },

    formatAndSetAmount(event, index) {
      let raw = event.target.value.replace(/,/g, "");
      if (!/^\d*\.?\d*$/.test(raw)) return;

      this.data.payments[index].amount = raw;

      this.$nextTick(() => {
        const el = event.target;
        if (el.value) {
          el.value = Number(raw).toLocaleString();
        }
        this.checkAndAddPaymentField(index);
      });
    },

    handleExportError() {
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "There was an error exporting customer deposits. Please try again.",
        confirmButtonText: "OK",
      });
    },
  },
  created() {
    this.FetchCustomerDeposits(this.filterDeposits);
    this.FetchCustomers();
    this.FetchPaymentOptions();
    this.setDefaultMode();
    this.fetchReceiptSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-4">
                <h4 class="card-title">Customer Deposits</h4>
              </div>
              <div
                v-if="MyUserPerm.add_customers == 1 && BranchData.BranchId != 0"
                class="col-12 col-md-4 text-md-end text-start"
              >
                <b-button v-b-modal.add-customer-modal variant="primary"
                  ><i class="fa fa-plus"></i> Add New Customer</b-button
                >
              </div>
              <div
                v-if="
                  MyUserPerm.add_customer_deposits == 1 &&
                  BranchData.BranchId != 0
                "
                class="col-12 col-md-4 text-md-end text-start"
              >
                <b-button v-b-modal.add-customerdeposit-modal variant="primary"
                  ><i class="fa fa-plus"></i> Add New Deposit</b-button
                >
              </div>
            </div>
            <div class="row mt-3 align-items-end">
              <div class="col-12 col-md-auto">
                <div class="form-group mb-3">
                  <label class="d-block invisible mb-1">Export</label>
                  <ExcelExport
                    endpoint="export_customer_deposits"
                    filename="customer_deposits_report.xlsx"
                    :payload="exportPayload"
                    button-text="Export Excel"
                    button-variant="info"
                    icon-class="fas fa-download"
                    @export-error="handleExportError"
                  />
                </div>
              </div>
              <div class="col-12 col-md-2">
                <div class="form-group mb-3">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="filterDeposits.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-12 col-md-2">
                <div class="form-group mb-3">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="filterDeposits.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-12 col-md-3">
                <div class="form-group mb-3">
                  <label>Search Customers</label>
                  <input
                    v-model="filterDeposits.search"
                    type="text"
                    class="form-control"
                    placeholder="Enter customer name or contact"
                    @keyup.enter="FilterReport()"
                  />
                </div>
              </div>
              <div class="col-12 col-md-auto">
                <div class="form-group mb-3 d-flex align-items-end h-100">
                  <button
                    class="btn btn-primary"
                    type="button"
                    @click="FilterReport()"
                  >
                    <span class="fa fa-filter"></span> Filter
                    <b-spinner
                      v-show="DepositsFilterStatus"
                      variant="light"
                      small
                      role="status"
                    ></b-spinner>
                  </button>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <div v-if="!IsDepositsServerPaginated">
                <b-table
                  class="datatables"
                  :items="CustomerDeposits ? CustomerDeposits : []"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>

                  <template #cell(amount)="data">
                    {{ data.item.amount.toLocaleString() }}
                  </template>

                  <template #cell(actions)="data">
                    <b-button
                      v-if="MyUserPerm.edit_customer_deposits == 1"
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-customerdeposit-modal
                      class="m-2"
                      @click="showEditModal(data.item)"
                      ><i class="fa fa-edit"></i
                    ></b-button>
                    <b-button
                      v-if="MyUserPerm.delete_customer_deposits == 1"
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-customerdeposit-modal
                      @click="showDeleteModal(data.item)"
                      ><i class="fa fa-trash"></i
                    ></b-button>
                  </template>
                </b-table>
              </div>
              <div v-else>
                <table
                  class="table table-striped table-bordered table-responsive nowrap w-100 datatables"
                >
                  <thead>
                    <tr>
                      <th v-for="field in fields" :key="field.key">
                        {{ field.label }}
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="
                      !DepositsFilterStatus &&
                      DepositsPaginated &&
                      DepositsPaginated.length > 0
                    "
                  >
                    <tr
                      v-for="(item, index) in DepositsPaginated"
                      :key="item.id"
                    >
                      <td>{{ calculateIndex(index) + 1 }}</td>
                      <td>{{ item.customer }}</td>
                      <td>{{ item.amount.toLocaleString() }}</td>
                      <td>{{ item.date }}</td>
                      <td>{{ item.mode }}</td>
                      <td>{{ item.description }}</td>
                      <td>{{ item.user }}</td>
                      <td>{{ item.added_on }}</td>
                      <td>
                        <b-button-group>
                          <b-button
                            v-if="MyUserPerm.edit_customer_deposits == 1"
                            size="sm"
                            variant="primary"
                            v-b-modal.edit-customerdeposit-modal
                            @click="showEditModal(item)"
                            ><i class="fa fa-edit"></i>
                          </b-button>
                          <b-button
                            v-if="MyUserPerm.delete_customer_deposits == 1"
                            size="sm"
                            variant="danger"
                            v-b-modal.delete-customerdeposit-modal
                            @click="showDeleteModal(item)"
                            ><i class="fa fa-trash"></i>
                          </b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="DepositsFilterStatus">
                    <tr>
                      <td :colspan="fields.length" class="text-center">
                        <div class="text-warning my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Loading...</strong>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    v-if="
                      !DepositsFilterStatus &&
                      (!DepositsPaginated || DepositsPaginated.length === 0)
                    "
                  >
                    <tr>
                      <td :colspan="fields.length" class="text-center">
                        No deposits found.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row text-center">
              <h5>
                Total Amount:
                <span class="text-danger">
                  {{ totals.totalAmount.toLocaleString() }}</span
                >
              </h5>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>            
          </div>
        </div>
      </div>
    </div>

    <!--Add customer modal starts -->
    <b-modal id="add-customer-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add Customer </template>

      <div class="form-group mb-3">
        <label>Customer Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Name "
            class="form-control"
            @input="resetError()"
            v-model="customerdata.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Customer Contact <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="number"
            placeholder="Enter Phone Number"
            class="form-control"
            v-model="customerdata.contact"
            @input="resetError()"
          />
        </div>
        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-customer-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-primary"
          disabled
        >
          <i class="fa fa-check"></i>
          Submit
          <b-spinner variant="light" small label="Spinning"></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="addCustomer('add-customer-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!--Add customer modal ends -->

    <!-- modal starts -->
    <b-modal id="add-customerdeposit-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add Customer deposit </template>
      <div class="form-group mb-3" v-if="MyUserPerm.backdate_payments == 1">
        <label>Date <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="date"
            placeholder="Enter date "
            class="form-control"
            v-model="data.date"
            max=""
            @input="resetError()"
          />
        </div>
        <div class="text-danger" v-if="dateError">
          <em>{{ dateError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Select Customer <span class="text-danger">*</span></label>
        <model-list-select
          :list="Customers ? Customers : []"
          v-model="data.customer"
          option-value="id"
          option-text="name"
          class="mb-3"
          placeholder="Select customer"
          @input="resetError()"
        >
        </model-list-select>
        <div class="text-danger" v-if="customerError">
          <em>{{ customerError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <div class="d-flex align-items-center">
          <label class="mb-0 mr-4">
            Amount <span class="text-danger">*</span>
          </label>
          <span class="my-1 px-5">
            <b-button
              variant="link"
              class="border border-primary border-1"
              v-b-modal.add-payments-modal
            >
              <i class="fa fa-columns"></i> Split Payment
            </b-button>
          </span>
        </div>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Amount "
            class="form-control"
            @input="AddCommas(), resetError()"
            v-model="data.amount"
          />
        </div>
        <div class="text-danger" v-if="amountError">
          <em>{{ amountError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Mode <span class="text-danger">*</span></label>
        <model-list-select
          :list="PaymentOptions ? PaymentOptions : []"
          v-model="data.mode"
          option-value="id"
          option-text="mode"
          class="mb-3"
          placeholder="Select mode"
          @input="resetError()"
          :is-disabled="splitPaymentActive"
        >
        </model-list-select>
        <div class="text-danger" v-if="modeError">
          <em>{{ modeError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Description</label>
        <div class="input-group">
          <textarea
            rows="3"
            class="form-control"
            v-model="data.description"
            placeholder="Description"
          >
          </textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-customerdeposit-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-primary"
          disabled
        >
          <i class="fa fa-check"></i>
          Submit
          <b-spinner variant="light" small label="Spinning"></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="addCustomerDeposit('add-customerdeposit-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- edit modal starts  -->
    <b-modal id="edit-customerdeposit-modal" hide-footer @hidden="resetEdit">
      <template #modal-title>
        Edit Customer deposit of {{ editdata.amount }}</template
      >
      <div class="form-group mb-3" v-if="MyUserPerm.backdate_payments == 1">
        <label>Date <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="date"
            class="form-control"
            @input="resetError()"
            v-model="editdata.date"
          />
        </div>
        <div class="text-danger" v-if="dateError">
          <em>{{ dateError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Amount <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          @input="AddCommas(), resetError()"
          v-model="editdata.amount"
        />
        <div class="text-danger" v-if="customerError">
          <em>{{ customerError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Description</label>
        <div class="input-group">
          <textarea
            rows="3"
            class="form-control"
            v-model="editdata.description"
            placeholder="Description"
          >
          </textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-customerdeposit-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-primary"
          disabled
        >
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner variant="light" small label="Saving"></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="editCustomerDeposit('edit-customerdeposit-modal')"
        >
          <i class="fa fa-check"></i>
          Save Changes
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete customer deposit starts -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-customerdeposit-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title>
        Delete Customer deposit of {{ deletedata.name }}</template
      >
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this record? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-customerdeposit-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteCustomerDeposit('delete-customerdeposit-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- SPLIT PAYMENTS MODAL -->
    <b-modal
      id="add-payments-modal"
      size="lg"
      hide-footer
      @hidden="onPaymentsModalHidden"
      title="Add Split Payments"
    >
      <div v-for="(payment, index) in data.payments" :key="index" class="mb-2">
        <div class="row align-items-center">
          <div class="col-6">
            <label v-if="index === 0">Payment Method</label>
            <model-list-select
              :list="PaymentOptions ? PaymentOptions : []"
              v-model="payment.method"
              option-value="id"
              option-text="mode"
              placeholder="Select Method"
              @input="checkAndAddPaymentField(index)"
            >
            </model-list-select>
          </div>
          <div class="col-4">
            <label v-if="index === 0">Amount Paid</label>
            <input
              :value="
                payment.amount ? Number(payment.amount).toLocaleString() : ''
              "
              @input="formatAndSetAmount($event, index)"
              class="form-control"
              placeholder="Enter Amount"
            />
          </div>
          <div class="col-2">
            <label v-if="index === 0 && data.payments.length > 1">Remove</label>
            <div class="d-flex align-items-end">
              <button
                v-if="data.payments.length > 1"
                class="btn btn-outline-danger"
                type="button"
                @click="removePaymentField(index)"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          @click="closeModal('add-payments-modal')"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="submitSplits('add-payments-modal')"
        >
          <i class="fa fa-check"></i> Submit Payments
        </button>
      </div>
    </b-modal>
    <!-- END SPLIT PAYMENTS MODAL -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
.btn-xs {
  padding: 0.25rem 0.4rem;
  font-size: 0.875rem;
  line-height: 0.5;
  border-radius: 0.2rem;
}
</style>